import Aos from "aos";
import { useEffect } from "react";

const plans = [
  {
    name: "Earn",
    tag: "Flexible top-ups",
    from: "₦50,000",
    desc: "Top up anytime and receive your interest monthly.",
    variant: "magenta",
  },
  {
    name: "Keep",
    tag: "Stay committed",
    from: "₦500,000",
    desc: "No top-ups. Receive your capital and interest at maturity.",
    variant: "gray",
  },
  {
    name: "Flex",
    tag: "Quarterly access",
    from: "₦500,000",
    desc:
      "No top-ups. Receive capital and interest at maturity, or withdraw once every three months on plans longer than six months.",
    variant: "green",
  },
  {
    name: "Build",
    tag: "Goal-focused",
    from: "₦100,000",
    desc:
      "Your capital and accrued interest will be paid out together at the end of the investment.",
    variant: "lavender",
  },
];

const BankvolePlansSection = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  return (
    <section className="bv-plans">
      <div className="bv-plans-header" data-aos="fade-up" data-aos-duration="1000">
        <span className="bv-eyebrow">OUR SERVICES</span>
        <h2 className="bv-plans-title">Choose a plan that fits your needs.</h2>
        <p className="bv-plans-subtitle">Multiple ways to grow your money, with clear terms and flexible  options.</p>
      </div>

      <div className="bv-plans-grid">
        {plans.map((plan, index) => (
          <div key={plan.name} className={`bv-plan-card bv-plan-card--${plan.variant}`} data-aos={index % 2 === 0 ? "fade-up" : "fade-up"} data-aos-duration="1000" data-aos-delay={index * 150} data-aos-easing="ease-in-out">
            <span className="bv-plan-tag">{plan.tag}</span>
            <h3 className="bv-plan-name">{plan.name}</h3>
            <p className="bv-plan-from">
              From <strong>{plan.from}</strong>
            </p>
            <p className="bv-plan-desc">{plan.desc}</p>

            <button className="bv-plan-arrow" aria-label={`Learn more about ${plan.name}`}>
              →
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BankvolePlansSection;